import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { TiPlus } from "react-icons/ti";
import { createManagerProduct, createProduct, createWorkerExtraWork } from "../productWarehouseApi";
import CreateManagerProductView from "../createManagerProductView";
import CreateWorkerExtraWorkView from "../createWorkerExtraWork";


export default function Create({ jwt, product, categories, workerExtraWorks, managerProducts, onCreated, show, onHide }) {

    const [localProduct, setLocalProduct] = useState({
        ...product,
        managerProductId: managerProducts.length > 0 ? managerProducts[0].id : null,
        workerExtraWorkdId: workerExtraWorks.length > 0 ? workerExtraWorks[0].id : null
    });

    const [localExtraWorks, setLocalExtraWorks] = useState([...workerExtraWorks]);
    const [localProducts, setLocalProducts] = useState([...managerProducts]);

    const [isCreateWorkerExtraWork, setIsCreateWorkerExtraWork] = useState(false);
    const [isCreateManagerProduct, setIsCreateManagerProduct] = useState(false);

    const submitProduct = async(e) => {
        e.preventDefault();

        const response = await createProduct({
            name: localProduct.name,
            productId: localProduct.managerProductId,
            extraWorkId: localProduct.workerExtraWorkdId,
            categoryId: localProduct.categoryId
        });

        if(response && response.id > 0)
            onCreated(localProduct);
        else alert('Что-то пошло не по плану, обратитесь в поддержку');
    }

    if(isCreateWorkerExtraWork)
        return <CreateWorkerExtraWorkView jwt={jwt}
                                        onCreated={(n) => {
                                            setLocalProduct({ ...localProduct, workerExtraWorkdId: n.id});
                                            setLocalExtraWorks([...localExtraWorks, n]);
                                            workerExtraWorks.push(n);
                                            setIsCreateWorkerExtraWork(false);
                                        }}
                                        onHide={() => setIsCreateWorkerExtraWork(false)}
                                        show={isCreateWorkerExtraWork}
                                        name={categories.find(c => c.id == localProduct.categoryId).name + ' ' + localProduct.name}/>

    if(isCreateManagerProduct)
        return <CreateManagerProductView jwt={jwt} 
                                        onCreated={(n) =>  {
                                            setLocalProduct({ ...localProduct, managerProductId: n.id});
                                            setLocalProducts([...localProducts, n]);
                                            managerProducts.push(n);
                                            setIsCreateManagerProduct(false);}}
                                        onHide={() => setIsCreateManagerProduct(false)}
                                        show={isCreateManagerProduct}
                                        name={categories.find(c => c.id == localProduct.categoryId).name + ' ' + localProduct.name}/>

    return <Modal show={show} onHide={onHide} size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
            <Form onSubmit={(e) => submitProduct(e)}>
        <Modal.Header closeButton>
            <Modal.Title>Создание {localProduct.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Название</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Продукция 1"
                        required
                        value={localProduct.name}
                        onChange={(e) => setLocalProduct({ ...localProduct, name: e.target.value })}
                    />
                </Form.Group>
              
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
                    <Form.Label>Категория</Form.Label>
                    <Form.Select aria-label="Default select categories" value={localProduct.categoryId ?? -1} onChange={(e) => setLocalProduct({ ...localProduct, categoryId: e.target.value == -1 ? null : e.target.value })}>
                        {
                            categories.map(o => <option key={o.id} value={o.id ?? -1}>{o.name}</option>)
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
                    <Form.Label>Работа</Form.Label>
                    <InputGroup>
                    <Form.Select aria-label="Default select worker Extra Work Id" value={localProduct.workerExtraWorkdId ?? -1} onChange={(e) => setLocalProduct({ ...localProduct, workerExtraWorkdId: e.target.value == -1 ? null : e.target.value })}>
                        {
                            localExtraWorks.map(o => <option key={o.id} value={o.id ?? -1}>{o.name}</option>)
                        }
                    </Form.Select>
                    <Button onClick={() => setIsCreateWorkerExtraWork(true)}><TiPlus/></Button>
                    </InputGroup>
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput42">
                    <Form.Label>Отправки</Form.Label>
                    <InputGroup>
                    <Form.Select required aria-label="Default select worker Extra Work Id" value={localProduct.managerProductId ?? -1} onChange={(e) => setLocalProduct({ ...localProduct, managerProductId: e.target.value == -1 ? null : e.target.value })}>
                        {
                            localProducts.map(o => <option key={o.id} value={o.id ?? -1}>{o.name}</option>)
                        }
                    </Form.Select>
                    <Button onClick={() => setIsCreateManagerProduct(true)}><TiPlus/></Button>
                    </InputGroup>
                </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>Отмена</Button>
            <Button variant="success" type="submit">Сохранить</Button>
        </Modal.Footer>
            </Form>
    </Modal>
}